

// // // // // // // import React, { useState, useEffect } from "react";
// // // // // // // import axios from "axios";
// // // // // // // import misionn from "../profileimage/mision.webp";
// // // // // // // import vision from "../profileimage/vision.jpg";
// // // // // // // import { FaEdit, FaSave } from "react-icons/fa";
// // // // // // // import "./missionvissioncards.css"
// // // // // // // const containerStyle = {
// // // // // // //   marginTop: "10px",
// // // // // // //   border: "1px solid #bbb",
// // // // // // //   borderRadius: "10px",
// // // // // // // };

// // // // // // // const cardWrapperStyle = {
// // // // // // //   // display: "flex",
// // // // // // //   justifyContent: "center",
// // // // // // //   gap: "40px",
// // // // // // //   overflowX: "auto",
// // // // // // //   flexWrap: "nowrap",
// // // // // // //   padding: "40px",
// // // // // // //   borderRadius: "20px",
// // // // // // //   border: "none"
// // // // // // // };

// // // // // // // const baseCardStyle = {
// // // // // // //   backgroundColor: "#fff",
// // // // // // //   borderRadius: "16px",
// // // // // // //   border: "1px solid #b15cd6",
// // // // // // //   padding: "35px 30px",
// // // // // // //   // width: "460px",
// // // // // // //   boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // // // // // //   textAlign: "center",
// // // // // // //   transition: "all 0.3s ease-in-out",
// // // // // // //   cursor: "default",
// // // // // // //   position: "relative",
// // // // // // // };

// // // // // // // const titleBaseStyle = {
// // // // // // //   fontSize: "26px",
// // // // // // //   fontWeight: "700",
// // // // // // //   marginBottom: "14px",
// // // // // // // };


// // // // // // // const sectionTitleStyle = {
// // // // // // //   textAlign: "center",
// // // // // // //   fontSize: "36px",
// // // // // // //   fontWeight: "800",
// // // // // // //   color: "rgb(177 93 198)",
// // // // // // //   letterSpacing: "0.5px",
// // // // // // //   marginBottom: "-20px",
// // // // // // //   marginTop: "10px",
// // // // // // // };

// // // // // // // const textAreaStyle = {
// // // // // // //   width: "100%",
// // // // // // //   padding: "10px",
// // // // // // //   borderRadius: "8px",
// // // // // // //   resize: "none",
// // // // // // //   fontSize: "16px",
// // // // // // // };

// // // // // // // const imageStyle = {
// // // // // // //   width: "80px",
// // // // // // //   height: "80px",
// // // // // // //   objectFit: "cover",
// // // // // // //   borderRadius: "50%",
// // // // // // //   marginBottom: "20px",
// // // // // // //   border: "2px solid #b15dc6",
// // // // // // // };

// // // // // // // // ✅ Card Component
// // // // // // // const Card = ({ image, title, value, onChange }) => {
// // // // // // //   return (
// // // // // // //     <div style={baseCardStyle} className="mission-vission-cards">
// // // // // // //       <img src={image} alt={title} style={imageStyle} />
// // // // // // //       <h3 style={titleBaseStyle}>{title}</h3>
// // // // // // //       <textarea
// // // // // // //         value={value}
// // // // // // //         onChange={(e) => onChange(e.target.value)}
// // // // // // //         rows={5}
// // // // // // //         style={textAreaStyle}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };


// // // // // // // // Main Component
// // // // // // // const MissionVisionCards = () => {
// // // // // // //   const [mission, setMission] = useState("");
// // // // // // //   const [visionDesc, setVisionDesc] = useState("");
// // // // // // //   const [vendorId, setVendorId] = useState(null);
// // // // // // //   const [aboutUsId, setAboutUsId] = useState(null);
// // // // // // //   const [isEditing, setIsEditing] = useState(false);

// // // // // // //   // Get vendorId from localStorage
// // // // // // //   useEffect(() => {
// // // // // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // // // // //     setVendorId(storedVendorId);
// // // // // // //   }, []);

// // // // // // //   // Fetch existing data
// // // // // // //   useEffect(() => {
// // // // // // //     if (vendorId) fetchAboutUsData(vendorId);
// // // // // // //   }, [vendorId]);

// // // // // // //   const fetchAboutUsData = async (vendorId) => {
// // // // // // //     const token = localStorage.getItem("authToken");
// // // // // // //     if (!token) return;

// // // // // // //     try {
// // // // // // //       const res = await axios.get(
// // // // // // //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// // // // // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // // // // //       );

// // // // // // //       const data = res.data;
// // // // // // //       setAboutUsId(data?.aboutUsId || null);
// // // // // // //       setMission(data?.mission || "");
// // // // // // //       setVisionDesc(data?.vision || "");
// // // // // // //     } catch (err) {
// // // // // // //       console.error("Fetch Error:", err.response?.data || err.message);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   // Send data (both POST and PUT) like About Us format
// // // // // // //   const sendMissionVision = async (method) => {
// // // // // // //     if (!vendorId) return alert("Vendor ID missing!");
// // // // // // //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// // // // // // //     const token = localStorage.getItem("authToken");
// // // // // // //     if (!token) return alert("Authorization token missing");

// // // // // // //     const aboutUsData = { mission, vision: visionDesc };
// // // // // // //     const formData = new FormData();
// // // // // // //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// // // // // // //     const url =
// // // // // // //       method === "POST"
// // // // // // //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// // // // // // //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// // // // // // //     try {
// // // // // // //       const res = await fetch(url, {
// // // // // // //         method,
// // // // // // //         headers: { Authorization: `Bearer ${token}` },
// // // // // // //         body: formData,
// // // // // // //       });

// // // // // // //       if (res.ok) {
// // // // // // //         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
// // // // // // //         fetchAboutUsData(vendorId);
// // // // // // //         setIsEditing(false);
// // // // // // //       } else {
// // // // // // //         const err = await res.json();
// // // // // // //         alert(`Failed: ${err.message || "Unknown error"}`);
// // // // // // //       }
// // // // // // //     } catch (err) {
// // // // // // //       console.error("Submit Error:", err);
// // // // // // //       alert("Something went wrong. Please try again.");
// // // // // // //     }
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <section style={containerStyle}>
// // // // // // //       <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
// // // // // // //         <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
// // // // // // //         <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
// // // // // // //           <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>Add +</button>
// // // // // // //           <button
// // // // // // //             onClick={() => {
// // // // // // //               if (isEditing) sendMissionVision("PUT");
// // // // // // //               else setIsEditing(true);
// // // // // // //             }}
// // // // // // //             style={{ ...buttonStyle, marginLeft: "10px" }}
// // // // // // //           >
// // // // // // //             {isEditing ? <FaSave /> : <FaEdit />}
// // // // // // //           </button>
// // // // // // //         </div>
// // // // // // //       </div>

// // // // // // //       <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
// // // // // // //         <Card image={misionn} title="Our Mission" value={mission} onChange={setMission} />
// // // // // // //         <Card image={vision} title="Our Vision" value={visionDesc} onChange={setVisionDesc} />
// // // // // // //       </div>
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // const buttonStyle = {
// // // // // // //   backgroundColor: "#b15dc6",
// // // // // // //   color: "#fff",
// // // // // // //   fontSize: "14px",
// // // // // // //   padding: "10px 15px",
// // // // // // //   borderRadius: "6px",
// // // // // // //   border: "none",
// // // // // // //   cursor: "pointer",
// // // // // // // };

// // // // // // // export default MissionVisionCards;








// // // // // // import React, { useState, useEffect } from "react";
// // // // // // import axios from "axios";
// // // // // // import misionn from "../profileimage/mision.webp";
// // // // // // import vision from "../profileimage/vision.jpg";
// // // // // // import { FaEdit, FaSave } from "react-icons/fa";
// // // // // // import "./missionvissioncards.css"

// // // // // // const containerStyle = {
// // // // // //   marginTop: "10px",
// // // // // //   border: "1px solid #bbb",
// // // // // //   borderRadius: "10px",
// // // // // // };

// // // // // // const cardWrapperStyle = {
// // // // // //   justifyContent: "center",
// // // // // //   gap: "40px",
// // // // // //   overflowX: "auto",
// // // // // //   flexWrap: "nowrap",
// // // // // //   padding: "40px",
// // // // // //   borderRadius: "20px",
// // // // // //   border: "none"
// // // // // // };

// // // // // // const baseCardStyle = {
// // // // // //   backgroundColor: "#fff",
// // // // // //   borderRadius: "16px",
// // // // // //   border: "1px solid #b15cd6",
// // // // // //   padding: "35px 30px",
// // // // // //   boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // // // // //   textAlign: "center",
// // // // // //   transition: "all 0.3s ease-in-out",
// // // // // //   cursor: "default",
// // // // // //   position: "relative",
// // // // // // };

// // // // // // const titleBaseStyle = {
// // // // // //   fontSize: "26px",
// // // // // //   fontWeight: "700",
// // // // // //   marginBottom: "14px",
// // // // // // };

// // // // // // const sectionTitleStyle = {
// // // // // //   textAlign: "center",
// // // // // //   fontSize: "36px",
// // // // // //   fontWeight: "800",
// // // // // //   color: "rgb(177 93 198)",
// // // // // //   letterSpacing: "0.5px",
// // // // // //   marginBottom: "-20px",
// // // // // //   marginTop: "10px",
// // // // // // };

// // // // // // const textAreaStyle = {
// // // // // //   width: "100%",
// // // // // //   padding: "10px",
// // // // // //   borderRadius: "8px",
// // // // // //   resize: "none",
// // // // // //   fontSize: "16px",
// // // // // // };

// // // // // // const imageStyle = {
// // // // // //   width: "80px",
// // // // // //   height: "80px",
// // // // // //   objectFit: "cover",
// // // // // //   borderRadius: "50%",
// // // // // //   marginBottom: "20px",
// // // // // //   border: "2px solid #b15dc6",
// // // // // // };

// // // // // // // Edit button style
// // // // // // const editButtonStyle = {
// // // // // //   position: "absolute",
// // // // // //   top: "15px",
// // // // // //   right: "15px",
// // // // // //   height: "25px",
// // // // // //   width: "25px",
// // // // // //   borderRadius: "50%",
// // // // // //   border: "none",
// // // // // //   background: "#b15cd6",
// // // // // //   color: "#fff",
// // // // // //   fontWeight: "bold",
// // // // // //   cursor: "pointer",
// // // // // //   display: "flex",
// // // // // //   alignItems: "center",
// // // // // //   justifyContent: "center",
// // // // // //   fontSize: "16px",
// // // // // //   boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
// // // // // //   zIndex: 10,
// // // // // // };

// // // // // // // ✅ Card Component
// // // // // // const Card = ({ 
// // // // // //   image, 
// // // // // //   title, 
// // // // // //   value, 
// // // // // //   onChange, 
// // // // // //   isEditing, 
// // // // // //   onEditToggle,
// // // // // //   fieldType 
// // // // // // }) => {
// // // // // //   return (
// // // // // //     <div style={baseCardStyle} className="mission-vission-cards">
// // // // // //       {/* Edit Button for each card */}
// // // // // //       <button 
// // // // // //         onClick={() => onEditToggle(fieldType)}
// // // // // //         style={editButtonStyle}
// // // // // //         title={isEditing ? "Save" : "Edit"}
// // // // // //       >
// // // // // //         {isEditing ? <FaSave /> : <FaEdit />}
// // // // // //       </button>

// // // // // //       <img src={image} alt={title} style={imageStyle} />
// // // // // //       <h3 style={titleBaseStyle}>{title}</h3>
// // // // // //       <textarea
// // // // // //         value={value}
// // // // // //         onChange={(e) => onChange(e.target.value)}
// // // // // //         rows={5}
// // // // // //         style={textAreaStyle}
// // // // // //         readOnly={!isEditing}
// // // // // //         placeholder={`Enter ${title.toLowerCase()}...`}
// // // // // //       />
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // // Main Component
// // // // // // const MissionVisionCards = () => {
// // // // // //   const [mission, setMission] = useState("");
// // // // // //   const [visionDesc, setVisionDesc] = useState("");
// // // // // //   const [vendorId, setVendorId] = useState(null);
// // // // // //   const [aboutUsId, setAboutUsId] = useState(null);
// // // // // //   const [editingField, setEditingField] = useState(null); // 'mission', 'vision', or null

// // // // // //   // Get vendorId from localStorage
// // // // // //   useEffect(() => {
// // // // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // // // //     setVendorId(storedVendorId);
// // // // // //   }, []);

// // // // // //   // Fetch existing data
// // // // // //   useEffect(() => {
// // // // // //     if (vendorId) fetchAboutUsData(vendorId);
// // // // // //   }, [vendorId]);

// // // // // //   const fetchAboutUsData = async (vendorId) => {
// // // // // //     const token = localStorage.getItem("authToken");
// // // // // //     if (!token) return;

// // // // // //     try {
// // // // // //       const res = await axios.get(
// // // // // //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// // // // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // // // //       );

// // // // // //       const data = res.data;
// // // // // //       setAboutUsId(data?.aboutUsId || null);
// // // // // //       setMission(data?.mission || "");
// // // // // //       setVisionDesc(data?.vision || "");
// // // // // //     } catch (err) {
// // // // // //       console.error("Fetch Error:", err.response?.data || err.message);
// // // // // //     }
// // // // // //   };

// // // // // //   // Send data (both POST and PUT) like About Us format
// // // // // //   const sendMissionVision = async (method) => {
// // // // // //     if (!vendorId) return alert("Vendor ID missing!");
// // // // // //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// // // // // //     const token = localStorage.getItem("authToken");
// // // // // //     if (!token) return alert("Authorization token missing");

// // // // // //     const aboutUsData = { mission, vision: visionDesc };
// // // // // //     const formData = new FormData();
// // // // // //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// // // // // //     const url =
// // // // // //       method === "POST"
// // // // // //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// // // // // //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// // // // // //     try {
// // // // // //       const res = await fetch(url, {
// // // // // //         method,
// // // // // //         headers: { Authorization: `Bearer ${token}` },
// // // // // //         body: formData,
// // // // // //       });

// // // // // //       if (res.ok) {
// // // // // //         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
// // // // // //         fetchAboutUsData(vendorId);
// // // // // //         setEditingField(null);
// // // // // //       } else {
// // // // // //         const err = await res.json();
// // // // // //         alert(`Failed: ${err.message || "Unknown error"}`);
// // // // // //       }
// // // // // //     } catch (err) {
// // // // // //       console.error("Submit Error:", err);
// // // // // //       alert("Something went wrong. Please try again.");
// // // // // //     }
// // // // // //   };

// // // // // //   const handleEditToggle = (fieldType) => {
// // // // // //     if (editingField === fieldType) {
// // // // // //       // Save and exit edit mode
// // // // // //       if (aboutUsId) {
// // // // // //         sendMissionVision("PUT");
// // // // // //       }
// // // // // //       setEditingField(null);
// // // // // //     } else {
// // // // // //       // Enter edit mode for this field
// // // // // //       setEditingField(fieldType);
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <section style={containerStyle}>
// // // // // //       <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
// // // // // //         <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
// // // // // //         <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
// // // // // //           <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>
// // // // // //             Add +
// // // // // //           </button>
// // // // // //         </div>
// // // // // //       </div>

// // // // // //       <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
// // // // // //         <Card 
// // // // // //           image={misionn} 
// // // // // //           title="Our Mission" 
// // // // // //           value={mission} 
// // // // // //           onChange={setMission}
// // // // // //           isEditing={editingField === 'mission'}
// // // // // //           onEditToggle={handleEditToggle}
// // // // // //           fieldType="mission"
// // // // // //         />
// // // // // //         <Card 
// // // // // //           image={vision} 
// // // // // //           title="Our Vision" 
// // // // // //           value={visionDesc} 
// // // // // //           onChange={setVisionDesc}
// // // // // //           isEditing={editingField === 'vision'}
// // // // // //           onEditToggle={handleEditToggle}
// // // // // //           fieldType="vision"
// // // // // //         />
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // const buttonStyle = {
// // // // // //   backgroundColor: "#b15dc6",
// // // // // //   color: "#fff",
// // // // // //   fontSize: "14px",
// // // // // //   padding: "10px 15px",
// // // // // //   borderRadius: "6px",
// // // // // //   border: "none",
// // // // // //   cursor: "pointer",
// // // // // // };

// // // // // // export default MissionVisionCards;

// // // // // import React, { useState, useEffect } from "react";
// // // // // import axios from "axios";
// // // // // import misionn from "../profileimage/mision.webp";
// // // // // import vision from "../profileimage/vision.jpg";
// // // // // import { FaEdit, FaSave } from "react-icons/fa";
// // // // // import "./missionvissioncards.css"

// // // // // const containerStyle = {
// // // // //   marginTop: "10px",
// // // // //   border: "1px solid #bbb",
// // // // //   borderRadius: "10px",
// // // // // };

// // // // // const cardWrapperStyle = {
// // // // //   justifyContent: "center",
// // // // //   gap: "40px",
// // // // //   overflowX: "auto",
// // // // //   flexWrap: "nowrap",
// // // // //   padding: "40px",
// // // // //   borderRadius: "20px",
// // // // //   border: "none"
// // // // // };

// // // // // const baseCardStyle = {
// // // // //   backgroundColor: "#fff",
// // // // //   borderRadius: "16px",
// // // // //   border: "1px solid #b15cd6",
// // // // //   padding: "35px 30px",
// // // // //   boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // // // //   textAlign: "center",
// // // // //   transition: "all 0.3s ease-in-out",
// // // // //   cursor: "default",
// // // // //   position: "relative",
// // // // // };

// // // // // const titleBaseStyle = {
// // // // //   fontSize: "26px",
// // // // //   fontWeight: "700",
// // // // //   marginBottom: "14px",
// // // // // };

// // // // // const sectionTitleStyle = {
// // // // //   textAlign: "center",
// // // // //   fontSize: "36px",
// // // // //   fontWeight: "800",
// // // // //   color: "rgb(177 93 198)",
// // // // //   letterSpacing: "0.5px",
// // // // //   marginBottom: "-20px",
// // // // //   marginTop: "10px",
// // // // // };

// // // // // const textAreaStyle = {
// // // // //   width: "100%",
// // // // //   padding: "10px",
// // // // //   borderRadius: "8px",
// // // // //   resize: "none",
// // // // //   fontSize: "16px",
// // // // // };

// // // // // const imageStyle = {
// // // // //   width: "80px",
// // // // //   height: "80px",
// // // // //   objectFit: "cover",
// // // // //   borderRadius: "50%",
// // // // //   marginBottom: "20px",
// // // // //   border: "2px solid #b15dc6",
// // // // // };

// // // // // // Edit button style
// // // // // const editButtonStyle = {
// // // // //   position: "absolute",
// // // // //   top: "15px",
// // // // //   right: "15px",
// // // // //   height: "25px",
// // // // //   width: "25px",
// // // // //   borderRadius: "50%",
// // // // //   border: "none",
// // // // //   background: "#b15cd6",
// // // // //   color: "#fff",
// // // // //   fontWeight: "bold",
// // // // //   cursor: "pointer",
// // // // //   display: "flex",
// // // // //   alignItems: "center",
// // // // //   justifyContent: "center",
// // // // //   fontSize: "16px",
// // // // //   boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
// // // // //   zIndex: 10,
// // // // // };

// // // // // // ✅ Card Component
// // // // // const Card = ({ 
// // // // //   image, 
// // // // //   title, 
// // // // //   value, 
// // // // //   onChange, 
// // // // //   isEditing, 
// // // // //   onEditToggle,
// // // // //   fieldType 
// // // // // }) => {
// // // // //   return (
// // // // //     <div style={baseCardStyle} className="mission-vission-cards">
// // // // //       {/* Edit Button for each card */}
// // // // //       <button 
// // // // //         onClick={() => onEditToggle(fieldType)}
// // // // //         style={editButtonStyle}
// // // // //         title={isEditing ? "Save" : "Edit"}
// // // // //       >
// // // // //         {isEditing ? <FaSave /> : <FaEdit />}
// // // // //       </button>

// // // // //       <img src={image} alt={title} style={imageStyle} />
// // // // //       <h3 style={titleBaseStyle}>{title}</h3>
// // // // //       <textarea
// // // // //         value={value}
// // // // //         onChange={(e) => onChange(e.target.value)}
// // // // //         rows={5}
// // // // //         style={textAreaStyle}
// // // // //         readOnly={!isEditing}
// // // // //         placeholder={`Enter ${title.toLowerCase()}...`}
// // // // //       />
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // // Main Component
// // // // // const MissionVisionCards = () => {
// // // // //   const [mission, setMission] = useState("");
// // // // //   const [visionDesc, setVisionDesc] = useState("");
// // // // //   const [vendorId, setVendorId] = useState(null);
// // // // //   const [aboutUsId, setAboutUsId] = useState(null);
// // // // //   const [editingField, setEditingField] = useState(null); // 'mission', 'vision', or null

// // // // //   // Get vendorId from localStorage
// // // // //   useEffect(() => {
// // // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // // //     setVendorId(storedVendorId);
// // // // //   }, []);

// // // // //   // Fetch existing data
// // // // //   useEffect(() => {
// // // // //     if (vendorId) fetchAboutUsData(vendorId);
// // // // //   }, [vendorId]);

// // // // //   const fetchAboutUsData = async (vendorId) => {
// // // // //     const token = localStorage.getItem("authToken");
// // // // //     if (!token) return;

// // // // //     try {
// // // // //       const res = await axios.get(
// // // // //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// // // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // // //       );

// // // // //       const data = res.data;
// // // // //       setAboutUsId(data?.aboutUsId || null);
// // // // //       setMission(data?.mission || "");
// // // // //       setVisionDesc(data?.vision || "");
// // // // //     } catch (err) {
// // // // //       console.error("Fetch Error:", err.response?.data || err.message);
// // // // //     }
// // // // //   };

// // // // //   // Send data (both POST and PUT) like About Us format
// // // // //   const sendMissionVision = async (method, fieldType = null) => {
// // // // //     if (!vendorId) return alert("Vendor ID missing!");
// // // // //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// // // // //     const token = localStorage.getItem("authToken");
// // // // //     if (!token) return alert("Authorization token missing");

// // // // //     const aboutUsData = { mission, vision: visionDesc };
// // // // //     const formData = new FormData();
// // // // //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// // // // //     const url =
// // // // //       method === "POST"
// // // // //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// // // // //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// // // // //     try {
// // // // //       const res = await fetch(url, {
// // // // //         method,
// // // // //         headers: { Authorization: `Bearer ${token}` },
// // // // //         body: formData,
// // // // //       });

// // // // //       if (res.ok) {
// // // // //         // Specific alert messages based on field type
// // // // //         if (method === "POST") {
// // // // //           alert("Mission & Vision added!");
// // // // //         } else {
// // // // //           if (fieldType === 'mission') {
// // // // //             alert("Mission updated successfully!");
// // // // //           } else if (fieldType === 'vision') {
// // // // //             alert("Vision updated successfully!");
// // // // //           } else {
// // // // //             alert("Mission & Vision updated!");
// // // // //           }
// // // // //         }
// // // // //         fetchAboutUsData(vendorId);
// // // // //         setEditingField(null);
// // // // //       } else {
// // // // //         const err = await res.json();
// // // // //         alert(`Failed: ${err.message || "Unknown error"}`);
// // // // //       }
// // // // //     } catch (err) {
// // // // //       console.error("Submit Error:", err);
// // // // //       alert("Something went wrong. Please try again.");
// // // // //     }
// // // // //   };

// // // // //   const handleEditToggle = (fieldType) => {
// // // // //     if (editingField === fieldType) {
// // // // //       // Save and exit edit mode
// // // // //       if (aboutUsId) {
// // // // //         sendMissionVision("PUT", fieldType);
// // // // //       }
// // // // //       setEditingField(null);
// // // // //     } else {
// // // // //       // Enter edit mode for this field
// // // // //       setEditingField(fieldType);
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <section style={containerStyle}>
// // // // //       <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
// // // // //         <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
// // // // //         <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
// // // // //           <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>
// // // // //             Add +
// // // // //           </button>
// // // // //         </div>
// // // // //       </div>

// // // // //       <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
// // // // //         <Card 
// // // // //           image={misionn} 
// // // // //           title="Our Mission" 
// // // // //           value={mission} 
// // // // //           onChange={setMission}
// // // // //           isEditing={editingField === 'mission'}
// // // // //           onEditToggle={handleEditToggle}
// // // // //           fieldType="mission"
// // // // //         />
// // // // //         <Card 
// // // // //           image={vision} 
// // // // //           title="Our Vision" 
// // // // //           value={visionDesc} 
// // // // //           onChange={setVisionDesc}
// // // // //           isEditing={editingField === 'vision'}
// // // // //           onEditToggle={handleEditToggle}
// // // // //           fieldType="vision"
// // // // //         />
// // // // //       </div>
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // const buttonStyle = {
// // // // //   backgroundColor: "#b15dc6",
// // // // //   color: "#fff",
// // // // //   fontSize: "14px",
// // // // //   padding: "10px 15px",
// // // // //   borderRadius: "6px",
// // // // //   border: "none",
// // // // //   cursor: "pointer",
// // // // // };

// // // // // export default MissionVisionCards;










// // // // import React, { useState, useEffect } from "react";
// // // // import axios from "axios";
// // // // import misionn from "../profileimage/mision.webp";
// // // // import vision from "../profileimage/vision.jpg";
// // // // import { FaEdit, FaSave, FaPlus, FaBullseye, FaEye } from "react-icons/fa";

// // // // const MissionVisionCards = () => {
// // // //   const [mission, setMission] = useState("");
// // // //   const [visionDesc, setVisionDesc] = useState("");
// // // //   const [vendorId, setVendorId] = useState(null);
// // // //   const [aboutUsId, setAboutUsId] = useState(null);
// // // //   const [editingField, setEditingField] = useState(null);
// // // //   const [isLoading, setIsLoading] = useState(false);

// // // //   // Get vendorId from localStorage
// // // //   useEffect(() => {
// // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // //     setVendorId(storedVendorId);
// // // //   }, []);

// // // //   // Fetch existing data
// // // //   useEffect(() => {
// // // //     if (vendorId) fetchAboutUsData(vendorId);
// // // //   }, [vendorId]);

// // // //   const fetchAboutUsData = async (vendorId) => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) return;

// // // //     setIsLoading(true);
// // // //     try {
// // // //       const res = await axios.get(
// // // //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );

// // // //       const data = res.data;
// // // //       setAboutUsId(data?.aboutUsId || null);
// // // //       setMission(data?.mission || "");
// // // //       setVisionDesc(data?.vision || "");
// // // //     } catch (err) {
// // // //       console.error("Fetch Error:", err.response?.data || err.message);
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   const sendMissionVision = async (method, fieldType = null) => {
// // // //     if (!vendorId) return alert("Vendor ID missing!");
// // // //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) return alert("Authorization token missing");

// // // //     setIsLoading(true);
// // // //     const aboutUsData = { mission, vision: visionDesc };
// // // //     const formData = new FormData();
// // // //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// // // //     const url =
// // // //       method === "POST"
// // // //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// // // //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// // // //     try {
// // // //       const res = await fetch(url, {
// // // //         method,
// // // //         headers: { Authorization: `Bearer ${token}` },
// // // //         body: formData,
// // // //       });

// // // //       if (res.ok) {
// // // //         if (method === "POST") {
// // // //           alert("Mission & Vision added successfully!");
// // // //         } else {
// // // //           if (fieldType === 'mission') {
// // // //             alert("Mission updated successfully!");
// // // //           } else if (fieldType === 'vision') {
// // // //             alert("Vision updated successfully!");
// // // //           } else {
// // // //             alert("Mission & Vision updated!");
// // // //           }
// // // //         }
// // // //         fetchAboutUsData(vendorId);
// // // //         setEditingField(null);
// // // //       } else {
// // // //         const err = await res.json();
// // // //         alert(`Failed: ${err.message || "Unknown error"}`);
// // // //       }
// // // //     } catch (err) {
// // // //       console.error("Submit Error:", err);
// // // //       alert("Something went wrong. Please try again.");
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   const handleEditToggle = (fieldType) => {
// // // //     if (editingField === fieldType) {
// // // //       if (aboutUsId) {
// // // //         sendMissionVision("PUT", fieldType);
// // // //       }
// // // //       setEditingField(null);
// // // //     } else {
// // // //       setEditingField(fieldType);
// // // //     }
// // // //   };

// // // //   const Card = ({
// // // //     image,
// // // //     title,
// // // //     value,
// // // //     onChange,
// // // //     isEditing,
// // // //     onEditToggle,
// // // //     fieldType,
// // // //     icon: Icon
// // // //   }) => {
// // // //     return (
// // // //       <div className="mission-card">
// // // //         <div className="card-header">
// // // //           {/* <div className="icon-wrapper">
// // // //             <Icon className="card-icon" />
// // // //           </div> */}
// // // //           <h3 className="card-title">{title}</h3>
// // // //           <button
// // // //             onClick={() => onEditToggle(fieldType)}
// // // //             className={`edit-button ${isEditing ? 'editing' : ''}`}
// // // //             title={isEditing ? "Save changes" : `Edit ${title.toLowerCase()}`}
// // // //             disabled={isLoading}
// // // //           >
// // // //             {isEditing ? <FaSave /> : <FaEdit />}
// // // //           </button>
// // // //         </div>

// // // //         <div className="card-content">
// // // //           <textarea
// // // //             value={value}
// // // //             onChange={(e) => onChange(e.target.value)}
// // // //             rows={6}
// // // //             className={`mission-textarea ${isEditing ? 'editing' : ''}`}
// // // //             readOnly={!isEditing}
// // // //             placeholder={`Describe your ${title.toLowerCase()}...`}
// // // //           />
// // // //           <div className="character-count">
// // // //             {value.length} characters
// // // //           </div>
// // // //         </div>

// // // //         {isEditing && (
// // // //           <div className="edit-indicator">
// // // //             <span>Editing mode</span>
// // // //           </div>
// // // //         )}
// // // //       </div>
// // // //     );
// // // //   };

// // // //   return (
// // // //     <section className="mission-vision-container">
// // // //       {/* Header Section */}
// // // //       <div className="mission-header">
// // // //         <div className="header-content">
// // // //           <h1 className="main-title">Our Commitments</h1>
// // // //           {/* <p className="subtitle">What drives us forward</p> */}
// // // //         </div>
// // // //         <button
// // // //           onClick={() => sendMissionVision("POST")}
// // // //           className="add-button"
// // // //           style={{
// // // //             width: "160px",
// // // //             padding: "1rem 0.5rem",
// // // //             display: "flex",
// // // //             alignItems: "center",
// // // //             justifyContent: "center",
// // // //           }}
// // // //           disabled={isLoading}
// // // //         >
// // // //           <FaPlus className="btn-icon" />
// // // //           <span>Add Content</span>
// // // //         </button>
// // // //       </div>

// // // //       {/* Cards Grid */}
// // // //       <div className="cards-grid">
// // // //         <Card
// // // //           image={misionn}
// // // //           title="Our Mission"
// // // //           value={mission}
// // // //           onChange={setMission}
// // // //           isEditing={editingField === 'mission'}
// // // //           onEditToggle={handleEditToggle}
// // // //           fieldType="mission"
// // // //           icon={FaBullseye}
// // // //         />
// // // //         <Card
// // // //           image={vision}
// // // //           title="Our Vision"
// // // //           value={visionDesc}
// // // //           onChange={setVisionDesc}
// // // //           isEditing={editingField === 'vision'}
// // // //           onEditToggle={handleEditToggle}
// // // //           fieldType="vision"
// // // //           icon={FaEye}
// // // //         />
// // // //       </div>

// // // //       {/* Loading Overlay */}
// // // //       {isLoading && (
// // // //         <div className="loading-overlay">
// // // //           <div className="loading-spinner"></div>
// // // //           <span>Saving changes...</span>
// // // //         </div>
// // // //       )}

// // // //       <style jsx>{`
// // // //         .mission-vision-container {
// // // //           background: linear-gradient(135deg, #fdfcff 0%, #f9f7ff 100%);
// // // //           min-height: 60vh;
// // // //           padding: 30px 20px;
// // // //           border-radius: 20px;
// // // //           margin: 20px;
// // // //           // border: 1px solid #f0eaff;
// // // //         }

// // // //         /* Header Styles */
// // // //         .mission-header {
// // // //           background: white;
// // // //           padding: 25px 30px;
// // // //           border-radius: 16px;
// // // //           margin-bottom: 30px;
// // // //           display: flex;
// // // //           justify-content: space-between;
// // // //           align-items: center;
// // // //           box-shadow: 0 4px 15px rgba(177, 92, 214, 0.08);
// // // //           // border: 1px solid #f0eaff;
// // // //         }

// // // //         .header-content {
// // // //           text-align: left;
// // // //         }

// // // //         .main-title {
// // // //           color: #8a4fbf;
// // // //           font-size: clamp(1.8rem, 3vw, 2.5rem);
// // // //           font-weight: 700;
// // // //           margin: 0 0 5px 0;
// // // //           font-family: 'Playfair Display', serif;
// // // //         }

// // // //         .subtitle {
// // // //           color: #888;
// // // //           font-size: 1rem;
// // // //           margin: 0;
// // // //           font-weight: 400;
// // // //         }

// // // //         .add-button {
// // // //           background: linear-gradient(135deg, #b15cd6, #8a4fbf);
// // // //           border: none;
// // // //           color: white;
// // // //           padding: 12px 24px;
// // // //           border-radius: 25px;
// // // //           cursor: pointer;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           gap: 8px;
// // // //           font-weight: 600;
// // // //           transition: all 0.3s ease;
// // // //           box-shadow: 0 4px 15px rgba(177, 92, 214, 0.3);
// // // //         }

// // // //         .add-button:hover:not(:disabled) {
// // // //           transform: translateY(-2px);
// // // //           box-shadow: 0 6px 20px rgba(177, 92, 214, 0.4);
// // // //         }

// // // //         .add-button:disabled {
// // // //           opacity: 0.6;
// // // //           cursor: not-allowed;
// // // //           transform: none;
// // // //         }

// // // //         /* Cards Grid */
// // // //         .cards-grid {
// // // //           display: grid;
// // // //           grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
// // // //           gap: 30px;
// // // //           align-items: start;
// // // //         }

// // // //         /* Card Styles */
// // // //         .mission-card {
// // // //           background: white;
// // // //           border-radius: 20px;
// // // //           padding: 30px;
// // // //           box-shadow: 0 8px 25px rgba(177, 92, 214, 0.1);
// // // //           // border: 1px solid #f0eaff;
// // // //           transition: all 0.3s ease;
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //         }

// // // //         .mission-card:hover {
// // // //           transform: translateY(-5px);
// // // //           box-shadow: 0 15px 35px rgba(177, 92, 214, 0.15);
// // // //         }

// // // //         .mission-card::before {
// // // //           content: '';
// // // //           position: absolute;
// // // //           top: 0;
// // // //           left: 0;
// // // //           right: 0;
// // // //           height: 4px;
// // // //           background: linear-gradient(90deg, #b15cd6, #8a4fbf);
// // // //         }

// // // //         .card-header {
// // // //           display: flex;
// // // //           align-items: center;
// // // //           gap: 15px;
// // // //           margin-bottom: 20px;
// // // //           position: relative;
// // // //         }

// // // //         .icon-wrapper {
// // // //           width: 50px;
// // // //           height: 50px;
// // // //           background: linear-gradient(135deg, #f8f5ff, #f0eaff);
// // // //           border-radius: 12px;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           // border: 2px solid #e6dcf8;
// // // //         }

// // // //         .card-icon {
// // // //           font-size: 1.5rem;
// // // //           color: #8a4fbf;
// // // //         }

// // // //         .card-title {
// // // //           color: #5d417b;
// // // //           font-size: 1.4rem;
// // // //           font-weight: 600;
// // // //           margin: 0;
// // // //           flex: 1;
// // // //         }

// // // //         .edit-button {
// // // //           background: #f8f5ff;
// // // //           border: 2px solid #e6dcf8;
// // // //           color: #8a4fbf;
// // // //           width: 40px;
// // // //           height: 40px;
// // // //           border-radius: 50%;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s ease;
// // // //           font-size: 1rem;
// // // //         }

// // // //         .edit-button:hover:not(:disabled) {
// // // //           background: #b15cd6;
// // // //           border-color: #b15cd6;
// // // //           color: white;
// // // //           transform: scale(1.1);
// // // //         }

// // // //         .edit-button.editing {
// // // //           background: #b15cd6;
// // // //           border-color: #b15cd6;
// // // //           color: white;
// // // //         }

// // // //         .edit-button:disabled {
// // // //           opacity: 0.5;
// // // //           cursor: not-allowed;
// // // //         }

// // // //         .card-content {
// // // //           position: relative;
// // // //         }

// // // //         .mission-textarea {
// // // //           width: 100%;
// // // //           background: #fcfaff;
// // // //           border: 0px solid #f0eaff;
// // // //           border-radius: 12px;
// // // //           color: #5d417b;
// // // //           font-size: 15px;
// // // //           line-height: 1.6;
// // // //           padding: 20px;
// // // //           resize: none;
// // // //           outline: none;
// // // //           transition: all 0.3s ease;
// // // //           font-family: 'Inter', sans-serif;
// // // //           min-height: 150px;
// // // //         }

// // // //         .mission-textarea:focus {
// // // //           border-color: #b15cd6;
// // // //           background: white;
// // // //           box-shadow: 0 0 0 3px rgba(177, 92, 214, 0.1);
// // // //         }

// // // //         .mission-textarea:read-only {
// // // //           background: #faf8ff;
// // // //           cursor: default;
// // // //         }

// // // //         .mission-textarea.editing {
// // // //           border-color: #b15cd6;
// // // //           background: white;
// // // //         }

// // // //         .mission-textarea::placeholder {
// // // //           color: #b8a9d4;
// // // //           font-style: italic;
// // // //         }

// // // //         .character-count {
// // // //           text-align: right;
// // // //           margin-top: 8px;
// // // //           color: #b8a9d4;
// // // //           font-size: 0.8rem;
// // // //           font-weight: 500;
// // // //         }

// // // //         .edit-indicator {
// // // //           position: absolute;
// // // //           top: 10px;
// // // //           right: 10px;
// // // //           background: #b15cd6;
// // // //           color: white;
// // // //           padding: 4px 8px;
// // // //           border-radius: 4px;
// // // //           font-size: 0.7rem;
// // // //           font-weight: 600;
// // // //         }

// // // //         /* Loading Overlay */
// // // //         .loading-overlay {
// // // //           position: fixed;
// // // //           top: 0;
// // // //           left: 0;
// // // //           right: 0;
// // // //           bottom: 0;
// // // //           background: rgba(0, 0, 0, 0.5);
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           color: white;
// // // //           z-index: 1000;
// // // //           gap: 15px;
// // // //         }

// // // //         .loading-spinner {
// // // //           width: 40px;
// // // //           height: 40px;
// // // //           border: 4px solid rgba(255, 255, 255, 0.3);
// // // //           border-top: 4px solid white;
// // // //           border-radius: 50%;
// // // //           animation: spin 1s linear infinite;
// // // //         }

// // // //         @keyframes spin {
// // // //           0% { transform: rotate(0deg); }
// // // //           100% { transform: rotate(360deg); }
// // // //         }

// // // //         /* Responsive Design */
// // // //         @media (max-width: 768px) {
// // // //           .mission-vision-container {
// // // //             margin: 10px;
// // // //             padding: 20px 15px;
// // // //           }

// // // //           .mission-header {
// // // //             flex-direction: column;
// // // //             gap: 20px;
// // // //             padding: 20px;
// // // //             text-align: center;
// // // //           }

// // // //           .header-content {
// // // //             text-align: center;
// // // //           }

// // // //           .cards-grid {
// // // //             grid-template-columns: 1fr;
// // // //             gap: 20px;
// // // //           }

// // // //           .mission-card {
// // // //             padding: 20px;
// // // //           }

// // // //           .card-header {
// // // //             flex-direction: column;
// // // //             gap: 12px;
// // // //             text-align: center;
// // // //           }

// // // //           .edit-button {
// // // //             position: absolute;
// // // //             top: 20px;
// // // //             right: 20px;
// // // //           }

// // // //           .mission-textarea {
// // // //             padding: 15px;
// // // //             min-height: 120px;
// // // //             font-size: 14px;
// // // //           }
// // // //         }

// // // //         @media (max-width: 480px) {
// // // //           .mission-vision-container {
// // // //             padding: 15px 10px;
// // // //             margin: 5px;
// // // //           }

// // // //           .mission-header {
// // // //             padding: 15px;
// // // //           }

// // // //           .mission-card {
// // // //             padding: 15px;
// // // //           }

// // // //           .main-title {
// // // //             font-size: 1.5rem;
// // // //           }

// // // //           .card-title {
// // // //             font-size: 1.2rem;
// // // //           }

// // // //           .icon-wrapper {
// // // //             width: 40px;
// // // //             height: 40px;
// // // //           }

// // // //           .card-icon {
// // // //             font-size: 1.2rem;
// // // //           }
// // // //         }

// // // //         @media (min-width: 1200px) {
// // // //           .cards-grid {
// // // //             grid-template-columns: repeat(2, 1fr);
// // // //           }
// // // //         }

// // // //         /* Print Styles */
// // // //         @media print {
// // // //           .edit-button, .add-button {
// // // //             display: none;
// // // //           }
          
// // // //           .mission-card {
// // // //             box-shadow: none;
// // // //             // border: 1px solid #ddd;
// // // //           }
// // // //         }

// // // //         /* Reduced motion for accessibility */
// // // //         @media (prefers-reduced-motion: reduce) {
// // // //           .mission-card, .edit-button, .add-button {
// // // //             transition: none;
// // // //           }
          
// // // //           .loading-spinner {
// // // //             animation: none;
// // // //           }
// // // //         }
// // // //       `}</style>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default MissionVisionCards;





// // // import React, { useState, useEffect } from "react";
// // // import axios from "axios";
// // // import misionn from "../profileimage/mision.webp";
// // // import vision from "../profileimage/vision.jpg";
// // // import { FaEdit, FaSave } from "react-icons/fa";
// // // import "./missionvissioncards.css"
// // // const containerStyle = {
// // //   marginTop: "10px",
// // //   border: "1px solid #bbb",
// // //   borderRadius: "10px",
// // // };

// // // const cardWrapperStyle = {
// // //   // display: "flex",
// // //   justifyContent: "center",
// // //   gap: "40px",
// // //   overflowX: "auto",
// // //   flexWrap: "nowrap",
// // //   padding: "40px",
// // //   borderRadius: "20px",
// // //   border: "none"
// // // };

// // // const baseCardStyle = {
// // //   backgroundColor: "#fff",
// // //   borderRadius: "16px",
// // //   border: "1px solid #b15cd6",
// // //   padding: "35px 30px",
// // //   // width: "460px",
// // //   boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
// // //   textAlign: "center",
// // //   transition: "all 0.3s ease-in-out",
// // //   cursor: "default",
// // //   position: "relative",
// // // };

// // // const titleBaseStyle = {
// // //   fontSize: "26px",
// // //   fontWeight: "700",
// // //   marginBottom: "14px",
// // // };


// // // const sectionTitleStyle = {
// // //   textAlign: "center",
// // //   fontSize: "36px",
// // //   fontWeight: "800",
// // //   color: "rgb(177 93 198)",
// // //   letterSpacing: "0.5px",
// // //   marginBottom: "-20px",
// // //   marginTop: "10px",
// // // };

// // // const textAreaStyle = {
// // //   width: "100%",
// // //   padding: "10px",
// // //   borderRadius: "8px",
// // //   resize: "none",
// // //   fontSize: "16px",
// // // };

// // // const imageStyle = {
// // //   width: "80px",
// // //   height: "80px",
// // //   objectFit: "cover",
// // //   borderRadius: "50%",
// // //   marginBottom: "20px",
// // //   border: "2px solid #b15dc6",
// // // };

// // // // ✅ Card Component
// // // const Card = ({ image, title, value, onChange }) => {
// // //   return (
// // //     <div style={baseCardStyle} className="mission-vission-cards">
// // //       <img src={image} alt={title} style={imageStyle} />
// // //       <h3 style={titleBaseStyle}>{title}</h3>
// // //       <textarea
// // //         value={value}
// // //         onChange={(e) => onChange(e.target.value)}
// // //         rows={5}
// // //         style={textAreaStyle}
// // //       />
// // //     </div>
// // //   );
// // // };


// // // // Main Component
// // // const MissionVisionCards = () => {
// // //   const [mission, setMission] = useState("");
// // //   const [visionDesc, setVisionDesc] = useState("");
// // //   const [vendorId, setVendorId] = useState(null);
// // //   const [aboutUsId, setAboutUsId] = useState(null);
// // //   const [isEditing, setIsEditing] = useState(false);

// // //   // Get vendorId from localStorage
// // //   useEffect(() => {
// // //     const storedVendorId = localStorage.getItem("vendorId");
// // //     setVendorId(storedVendorId);
// // //   }, []);

// // //   // Fetch existing data
// // //   useEffect(() => {
// // //     if (vendorId) fetchAboutUsData(vendorId);
// // //   }, [vendorId]);

// // //   const fetchAboutUsData = async (vendorId) => {
// // //     const token = localStorage.getItem("authToken");
// // //     if (!token) return;

// // //     try {
// // //       const res = await axios.get(
// // //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// // //         { headers: { Authorization: `Bearer ${token}` } }
// // //       );

// // //       const data = res.data;
// // //       setAboutUsId(data?.aboutUsId || null);
// // //       setMission(data?.mission || "");
// // //       setVisionDesc(data?.vision || "");
// // //     } catch (err) {
// // //       console.error("Fetch Error:", err.response?.data || err.message);
// // //     }
// // //   };

// // //   // Send data (both POST and PUT) like About Us format
// // //   const sendMissionVision = async (method) => {
// // //     if (!vendorId) return alert("Vendor ID missing!");
// // //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// // //     const token = localStorage.getItem("authToken");
// // //     if (!token) return alert("Authorization token missing");

// // //     const aboutUsData = { mission, vision: visionDesc };
// // //     const formData = new FormData();
// // //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// // //     const url =
// // //       method === "POST"
// // //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// // //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// // //     try {
// // //       const res = await fetch(url, {
// // //         method,
// // //         headers: { Authorization: `Bearer ${token}` },
// // //         body: formData,
// // //       });

// // //       if (res.ok) {
// // //         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
// // //         fetchAboutUsData(vendorId);
// // //         setIsEditing(false);
// // //       } else {
// // //         const err = await res.json();
// // //         alert(`Failed: ${err.message || "Unknown error"}`);
// // //       }
// // //     } catch (err) {
// // //       console.error("Submit Error:", err);
// // //       alert("Something went wrong. Please try again.");
// // //     }
// // //   };

// // //   return (
// // //     <section style={containerStyle}>
// // //       <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
// // //         <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
// // //         <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
// // //           <button onClick={() => sendMissionVision("POST")} style={buttonStyle}>Add +</button>
// // //           <button
// // //             onClick={() => {
// // //               if (isEditing) sendMissionVision("PUT");
// // //               else setIsEditing(true);
// // //             }}
// // //             style={{ ...buttonStyle, marginLeft: "10px" }}
// // //           >
// // //             {isEditing ? <FaSave /> : <FaEdit />}
// // //           </button>
// // //         </div>
// // //       </div>

// // //       <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
// // //         <Card image={misionn} title="Our Mission" value={mission} onChange={setMission} />
// // //         <Card image={vision} title="Our Vision" value={visionDesc} onChange={setVisionDesc} />
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // const buttonStyle = {
// // //   backgroundColor: "#b15dc6",
// // //   color: "#fff",
// // //   fontSize: "14px",
// // //   padding: "10px 15px",
// // //   borderRadius: "6px",
// // //   border: "none",
// // //   cursor: "pointer",
// // // };

// // // export default MissionVisionCards;



// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import misionn from "../profileimage/mision.webp";
// // import vision from "../profileimage/vision.jpg";
// // import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// // import "./missionvissioncards.css"

// // const MissionVisionCards = () => {
// //   const [mission, setMission] = useState("");
// //   const [visionDesc, setVisionDesc] = useState("");
// //   const [vendorId, setVendorId] = useState(null);
// //   const [aboutUsId, setAboutUsId] = useState(null);
// //   const [isMissionEditing, setIsMissionEditing] = useState(false);
// //   const [isVisionEditing, setIsVisionEditing] = useState(false);
// //   const [showMissionEditButton, setShowMissionEditButton] = useState(false);
// //   const [showVisionEditButton, setShowVisionEditButton] = useState(false);
// //   const [showThreeDots, setShowThreeDots] = useState(true);
// //   const [showEditOptions, setShowEditOptions] = useState(false);
  
// //   const timeoutRef = useRef(null);
// //   const editOptionsRef = useRef(null);
// //   const threeDotsRef = useRef(null);

// //   // Get vendorId from localStorage
// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     setVendorId(storedVendorId);
// //   }, []);

// //   // Fetch existing data
// //   useEffect(() => {
// //     if (vendorId) fetchAboutUsData(vendorId);
// //   }, [vendorId]);

// //   // Click outside detection for edit options
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       // If edit options are open and click is outside both edit options and three dots button
// //       if (showEditOptions && 
// //           editOptionsRef.current && 
// //           !editOptionsRef.current.contains(event.target) &&
// //           threeDotsRef.current && 
// //           !threeDotsRef.current.contains(event.target)) {
// //         setShowEditOptions(false);
// //         setShowThreeDots(true);
// //       }
// //     };

// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     };
// //   }, [showEditOptions]);

// //   // Auto-hide edit buttons after 5 seconds ONLY when NOT editing
// //   useEffect(() => {
// //     // Don't auto-hide if user is actively editing
// //     if (isMissionEditing || isVisionEditing) {
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //       return;
// //     }

// //     if (showMissionEditButton || showVisionEditButton) {
// //       // Clear existing timeout
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
      
// //       // Set new timeout only when not editing
// //       timeoutRef.current = setTimeout(() => {
// //         setShowMissionEditButton(false);
// //         setShowVisionEditButton(false);
// //         setShowThreeDots(true);
// //         setShowEditOptions(false);
// //       }, 5000); // 5 seconds
// //     }

// //     // Cleanup timeout on unmount
// //     return () => {
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //     };
// //   }, [showMissionEditButton, showVisionEditButton, isMissionEditing, isVisionEditing]);

// //   const fetchAboutUsData = async (vendorId) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) return;

// //     try {
// //       const res = await axios.get(
// //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       const data = res.data;
// //       setAboutUsId(data?.aboutUsId || null);
// //       setMission(data?.mission || "");
// //       setVisionDesc(data?.vision || "");
// //     } catch (err) {
// //       console.error("Fetch Error:", err.response?.data || err.message);
// //     }
// //   };

// //   // Send data (both POST and PUT) like About Us format
// //   const sendMissionVision = async (method) => {
// //     if (!vendorId) return alert("Vendor ID missing!");
// //     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

// //     const token = localStorage.getItem("authToken");
// //     if (!token) return alert("Authorization token missing");

// //     const aboutUsData = { mission, vision: visionDesc };
// //     const formData = new FormData();
// //     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

// //     const url =
// //       method === "POST"
// //         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
// //         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

// //     try {
// //       const res = await fetch(url, {
// //         method,
// //         headers: { Authorization: `Bearer ${token}` },
// //         body: formData,
// //       });

// //       if (res.ok) {
// //         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
// //         fetchAboutUsData(vendorId);
// //         setIsMissionEditing(false);
// //         setIsVisionEditing(false);
// //         return true;
// //       } else {
// //         const err = await res.json();
// //         alert(`Failed: ${err.message || "Unknown error"}`);
// //         return false;
// //       }
// //     } catch (err) {
// //       console.error("Submit Error:", err);
// //       alert("Something went wrong. Please try again.");
// //       return false;
// //     }
// //   };

// //   const handleAddMissionVision = async () => {
// //     await sendMissionVision("POST");
// //   };

// //   const handleMissionEditSaveToggle = async () => {
// //     if (isMissionEditing && aboutUsId) {
// //       const success = await sendMissionVision("PUT");
// //       if (success) {
// //         setShowMissionEditButton(true);
// //         setIsMissionEditing(false);
// //       }
// //     } else {
// //       setIsMissionEditing(true);
// //       setShowMissionEditButton(true);
// //     }
// //   };

// //   const handleVisionEditSaveToggle = async () => {
// //     if (isVisionEditing && aboutUsId) {
// //       const success = await sendMissionVision("PUT");
// //       if (success) {
// //         setShowVisionEditButton(true);
// //         setIsVisionEditing(false);
// //       }
// //     } else {
// //       setIsVisionEditing(true);
// //       setShowVisionEditButton(true);
// //     }
// //   };

// //   const handleThreeDotsClick = () => {
// //     setShowThreeDots(false);
// //     setShowEditOptions(true);
// //   };

// //   const handleEditMissionClick = () => {
// //     setShowEditOptions(false);
// //     setShowMissionEditButton(true);
// //   };

// //   const handleEditVisionClick = () => {
// //     setShowEditOptions(false);
// //     setShowVisionEditButton(true);
// //   };

// //   // Card Component
// //   const Card = ({ image, title, value, onChange, isEditing, showEditButton, onEditToggle }) => {
// //     return (
// //       <div style={{
// //         backgroundColor: "white",
// //         borderRadius: "20px",
// //         padding: "20px",
// //         width: "48%",
// //         boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //         textAlign: "center",
// //         position: "relative",
// //         border: "none"
// //       }} className="mission-vission-cards">
// //         <div className="d-flex justify-content-between align-items-center mb-2">
// //           <h5 style={{ color: "#b15cd6", margin: "5px" }}>{title}</h5>
// //           {showEditButton && (
// //             <button onClick={onEditToggle} style={sectionButtonStyle}>
// //               {isEditing ? <FaSave /> : <FaEdit />}
// //             </button>
// //           )}
// //         </div>
// //         <img 
// //           src={image} 
// //           alt={title} 
// //           style={{
// //             width: "80px",
// //             height: "80px",
// //             objectFit: "cover",
// //             borderRadius: "50%",
// //             marginBottom: "20px",
// //             border: "2px solid #b15dc6",
// //           }} 
// //         />
// //         <textarea
// //           value={value}
// //           onChange={(e) => onChange(e.target.value)}
// //           rows={5}
// //           readOnly={!isEditing}
// //           style={{
// //             width: "100%",
// //             fontSize: "16px",
// //             color: "#333",
// //             lineHeight: "1.2",
// //             textAlign: "justify",
// //             border: "0px solid transparent !important",
// //             boxShadow: "none !important",
// //             fontFamily: "math",
// //             resize: "none",
// //             outline: "none",
// //             backgroundColor: "#f5f4f4",
// //             borderRadius: "8px",
// //             padding: "10px",
// //           }}
// //           className="hide-scrollbar"
// //         />
// //       </div>
// //     );
// //   };

// //   return (
// //     <div style={{ 
// //       border: "none", 
// //       borderRadius: "20px", 
// //       marginTop: "30px", 
// //       backgroundColor: "#b15dc6",
// //       padding: "20px 0"
// //     }}>
// //       <div className="d-flex w-100 px-4 pt-3"
// //         style={{
// //           justifyContent: "space-around",
// //         }}
// //       >
// //         <h1
// //           style={{
// //             color: "#ffffffff",
// //             fontWeight: "bold",
// //             textAlign: "center",
// //             marginBottom: "10px",
// //           }}
// //         >
// //           OUR COMMITMENTS
// //         </h1>

// //         <button onClick={handleAddMissionVision} style={buttonStyle}>
// //           Add+
// //         </button>
// //       </div>

// //       {/* Combined Mission and Vision Section in a single div */}
// //       <div
// //         className="p-4 position-relative"
// //         style={{
// //           backgroundColor: "white",
// //           margin: "10px",
// //           borderRadius: "20px",
// //           display: "flex",
// //           flexDirection: "row",
// //           gap: "20px",
// //           width: "calc(100% - 20px)",
// //           alignItems: "center",
// //           justifyContent: "space-between",
// //         }}
// //       >
// //         {/* Three Dots Button */}
// //         {showThreeDots && (
// //           <button 
// //             ref={threeDotsRef}
// //             onClick={handleThreeDotsClick}
// //             style={threeDotsStyle}
// //             title="Toggle edit buttons"
// //           >
// //             <FaEllipsisV />
// //           </button>
// //         )}

// //         {/* Edit Options (Edit Mission & Edit Vision buttons) */}
// //         {showEditOptions && (
// //           <div ref={editOptionsRef} style={editOptionsStyle}>
// //             <button onClick={handleEditMissionClick} style={editOptionButtonStyle}>
// //               Edit Mission
// //             </button>
// //             <button onClick={handleEditVisionClick} style={editOptionButtonStyle}>
// //               Edit Vision
// //             </button>
// //           </div>
// //         )}

// //         {/* Mission Section */}
// //         <Card 
// //           image={misionn} 
// //           title="Our Mission" 
// //           value={mission} 
// //           onChange={setMission}
// //           isEditing={isMissionEditing}
// //           showEditButton={showMissionEditButton}
// //           onEditToggle={handleMissionEditSaveToggle}
// //         />

// //         {/* Vision Section */}
// //         <Card 
// //           image={vision} 
// //           title="Our Vision" 
// //           value={visionDesc} 
// //           onChange={setVisionDesc}
// //           isEditing={isVisionEditing}
// //           showEditButton={showVisionEditButton}
// //           onEditToggle={handleVisionEditSaveToggle}
// //         />
// //       </div>
      
// //       <style>
// //         {`
// //           /* Hide scrollbar across all platforms */
// //           .hide-scrollbar::-webkit-scrollbar {
// //             display: none;
// //             width: 0;
// //             height: 0;
// //           }
          
// //           .hide-scrollbar {
// //             -ms-overflow-style: none;
// //             scrollbar-width: none;
// //             border:none !important;
// //           }
// //         `}
// //       </style>
// //     </div>
// //   );
// // };

// // const buttonStyle = {
// //   height: "35px",
// //   borderRadius: "5px",
// //   border: "none",
// //   color: "#b15cd6",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "80px",
// //   marginLeft: "20px",
// //   marginTop: "8px",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const sectionButtonStyle = {
// //   height: "25px",
// //   borderRadius: "50%",
// //   border: "none",
// //   background: "#b15cd6",
// //   color: "#fff",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "auto",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const threeDotsStyle = {
// //   position: "absolute",
// //   top: "10px",
// //   right: "0px",
// //   background: "transparent",
// //   border: "none",
// //   color: "#b15cd6",
// //   cursor: "pointer",
// //   fontSize: "18px",
// //   padding: "5px",
// //   borderRadius: "50%",
// //   zIndex: 10,
// // };

// // const editOptionsStyle = {
// //   position: "absolute",
// //   top: "10px",
// //   right: "10px",
// //   background: "white",
// //   border: "1px solid #b15cd6",
// //   borderRadius: "8px",
// //   padding: "8px",
// //   display: "flex",
// //   flexDirection: "column",
// //   gap: "5px",
// //   boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// //   zIndex: 10,
// // };

// // const editOptionButtonStyle = {
// //   background: "transparent",
// //   border: "none",
// //   color: "#b15cd6",
// //   cursor: "pointer",
// //   fontSize: "14px",
// //   padding: "5px 10px",
// //   borderRadius: "4px",
// //   textAlign: "left",
// //   fontWeight: "500",
// // };

// // export default MissionVisionCards;



















// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import misionn from "../profileimage/mision.webp";
// import vision from "../profileimage/vision.jpg";
// import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// import "./missionvissioncards.css"

// const MissionVisionCards = () => {
//   const [mission, setMission] = useState("");
//   const [visionDesc, setVisionDesc] = useState("");
//   const [vendorId, setVendorId] = useState(null);
//   const [aboutUsId, setAboutUsId] = useState(null);
//   const [isMissionEditing, setIsMissionEditing] = useState(false);
//   const [isVisionEditing, setIsVisionEditing] = useState(false);
//   const [showMissionEditButton, setShowMissionEditButton] = useState(false);
//   const [showVisionEditButton, setShowVisionEditButton] = useState(false);
//   const [showMissionThreeDots, setShowMissionThreeDots] = useState(true);
//   const [showVisionThreeDots, setShowVisionThreeDots] = useState(true);
  
//   const timeoutRef = useRef(null);
//   const missionEditButtonRef = useRef(null);
//   const visionEditButtonRef = useRef(null);
//   const missionThreeDotsRef = useRef(null);
//   const visionThreeDotsRef = useRef(null);

//   // Get vendorId from localStorage
//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     setVendorId(storedVendorId);
//   }, []);

//   // Fetch existing data
//   useEffect(() => {
//     if (vendorId) fetchAboutUsData(vendorId);
//   }, [vendorId]);

//   // Click outside detection - hide edit buttons immediately
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const isMissionEditButtonClicked = missionEditButtonRef.current?.contains(event.target);
//       const isVisionEditButtonClicked = visionEditButtonRef.current?.contains(event.target);
//       const isMissionThreeDotsClicked = missionThreeDotsRef.current?.contains(event.target);
//       const isVisionThreeDotsClicked = visionThreeDotsRef.current?.contains(event.target);
      
//       const isAnyInteractiveElementClicked = 
//         isMissionEditButtonClicked || 
//         isVisionEditButtonClicked || 
//         isMissionThreeDotsClicked || 
//         isVisionThreeDotsClicked;

//       // If click is outside ALL interactive elements, hide everything immediately
//       if (!isAnyInteractiveElementClicked) {
//         // Only hide if not currently editing
//         if (!isMissionEditing) {
//           setShowMissionEditButton(false);
//           setShowMissionThreeDots(true);
//         }
//         if (!isVisionEditing) {
//           setShowVisionEditButton(false);
//           setShowVisionThreeDots(true);
//         }
        
//         // Clear timeout since we're hiding immediately
//         if (timeoutRef.current) {
//           clearTimeout(timeoutRef.current);
//         }
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMissionEditing, isVisionEditing]);

//   // Auto-hide edit buttons after 5 seconds when visible (only when not editing)
//   useEffect(() => {
//     // Don't auto-hide if user is actively editing
//     if (isMissionEditing || isVisionEditing) {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//       return;
//     }

//     // Set timeout for auto-hiding only when edit buttons are visible
//     const shouldAutoHide = showMissionEditButton || showVisionEditButton;

//     if (shouldAutoHide) {
//       // Clear existing timeout
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
      
//       // Set new timeout only when not editing
//       timeoutRef.current = setTimeout(() => {
//         setShowMissionEditButton(false);
//         setShowVisionEditButton(false);
//         setShowMissionThreeDots(true);
//         setShowVisionThreeDots(true);
//       }, 5000); // 5 seconds
//     }

//     // Cleanup timeout on unmount
//     return () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, [showMissionEditButton, showVisionEditButton, isMissionEditing, isVisionEditing]);

//   const fetchAboutUsData = async (vendorId) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) return;

//     try {
//       const res = await axios.get(
//         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const data = res.data;
//       setAboutUsId(data?.aboutUsId || null);
//       setMission(data?.mission || "");
//       setVisionDesc(data?.vision || "");
//     } catch (err) {
//       console.error("Fetch Error:", err.response?.data || err.message);
//     }
//   };

//   // Send data (both POST and PUT) like About Us format
//   const sendMissionVision = async (method) => {
//     if (!vendorId) return alert("Vendor ID missing!");
//     if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

//     const token = localStorage.getItem("authToken");
//     if (!token) return alert("Authorization token missing");

//     const aboutUsData = { mission, vision: visionDesc };
//     const formData = new FormData();
//     formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

//     const url =
//       method === "POST"
//         ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
//         : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

//     try {
//       const res = await fetch(url, {
//         method,
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       if (res.ok) {
//         alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
//         fetchAboutUsData(vendorId);
//         setIsMissionEditing(false);
//         setIsVisionEditing(false);
//         return true;
//       } else {
//         const err = await res.json();
//         alert(`Failed: ${err.message || "Unknown error"}`);
//         return false;
//       }
//     } catch (err) {
//       console.error("Submit Error:", err);
//       alert("Something went wrong. Please try again.");
//       return false;
//     }
//   };

//   const handleAddMissionVision = async () => {
//     await sendMissionVision("POST");
//   };

//   // Step 1: Three dots click - shows edit button
//   const handleMissionThreeDotsClick = () => {
//     setShowMissionThreeDots(false);
//     setShowMissionEditButton(true);
//     // Close vision elements
//     setShowVisionEditButton(false);
//     setShowVisionThreeDots(true);
    
//     // Reset timeout
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   };

//   const handleVisionThreeDotsClick = () => {
//     setShowVisionThreeDots(false);
//     setShowVisionEditButton(true);
//     // Close mission elements
//     setShowMissionEditButton(false);
//     setShowMissionThreeDots(true);
    
//     // Reset timeout
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//   };

//   // Step 2 & 3: Edit/Save button click - toggles between edit and save
//   const handleMissionEditSaveToggle = async () => {
//     if (isMissionEditing) {
//       // Step 3: Save - Save changes and go back to three dots
//       if (aboutUsId) {
//         const success = await sendMissionVision("PUT");
//         if (success) {
//           setShowMissionEditButton(false);
//           setShowMissionThreeDots(true);
//           setIsMissionEditing(false);
//         }
//       }
//     } else {
//       // Step 2: Edit - Enable editing and show save button
//       setIsMissionEditing(true);
//       setShowMissionEditButton(true);
//       setShowMissionThreeDots(false);
      
//       // Clear timeout when starting to edit
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     }
//   };

//   const handleVisionEditSaveToggle = async () => {
//     if (isVisionEditing) {
//       // Step 3: Save - Save changes and go back to three dots
//       if (aboutUsId) {
//         const success = await sendMissionVision("PUT");
//         if (success) {
//           setShowVisionEditButton(false);
//           setShowVisionThreeDots(true);
//           setIsVisionEditing(false);
//         }
//       }
//     } else {
//       // Step 2: Edit - Enable editing and show save button
//       setIsVisionEditing(true);
//       setShowVisionEditButton(true);
//       setShowVisionThreeDots(false);
      
//       // Clear timeout when starting to edit
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     }
//   };

//   // Card Component
//   const Card = ({ 
//     image, 
//     title, 
//     value, 
//     onChange, 
//     isEditing, 
//     showEditButton, 
//     onEditToggle,
//     showThreeDots,
//     onThreeDotsClick,
//     editButtonRef,
//     threeDotsRef
//   }) => {
//     return (
//       <div style={{
//         backgroundColor: "white",
//         borderRadius: "20px",
//         padding: "20px",
//         width: "48%",
//         boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
//         textAlign: "center",
//         position: "relative",
//         border: "none"
//       }} className="mission-vission-cards">
        
//         {/* Header with title and edit/save button */}
//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <h5 style={{ color: "#b15cd6", margin: "5px" }}>{title}</h5>
//           {showEditButton && (
//             <button 
//               ref={editButtonRef}
//               onClick={onEditToggle} 
//               style={sectionButtonStyle}
//               title={isEditing ? "Save Changes" : "Edit Content"}
//             >
//               {isEditing ? <FaSave /> : <FaEdit />}
//             </button>
//           )}
//         </div>

//         {/* Three Dots Button - Step 1 */}
//         {showThreeDots && (
//           <button 
//             ref={threeDotsRef}
//             onClick={onThreeDotsClick}
//             style={threeDotsStyle}
//             title={`Edit ${title}`}
//           >
//             <FaEllipsisV />
//           </button>
//         )}

//         {/* Image */}
//         <img 
//           src={image} 
//           alt={title} 
//           style={{
//             width: "80px",
//             height: "80px",
//             objectFit: "cover",
//             borderRadius: "50%",
//             marginBottom: "20px",
//             border: "2px solid #b15dc6",
//           }} 
//         />

//         {/* Textarea */}
//         <textarea
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           rows={5}
//           readOnly={!isEditing}
          
//           style={{
//             width: "100%",
//             fontSize: "16px",
//             color: "#333",
//             lineHeight: "1.2",
//             textAlign: "justify",
//             border: isEditing ? "0px solid transparent" : "0px solid transparent",
//             boxShadow: isEditing ? "none" : "none",
//             fontFamily: "math",
//             resize: "none",
//             outline: "none",
//             backgroundColor: isEditing ? "#f5f4f4" : "#f5f4f4",
//             borderRadius: "8px",
//             padding: "10px",
//             transition: "all 0.3s ease",
//           }}
//           className="hide-scrollbar"
//         />
//       </div>
//     );
//   };

//   return (
//     <div style={{ 
//       border: "none", 
//       borderRadius: "20px", 
//       marginTop: "30px", 
//       backgroundColor: "#b15dc6",
//       padding: "20px 0"
//     }}>
//       <div className="d-flex w-100 px-4 pt-3"
//         style={{
//           justifyContent: "space-around",
//         }}
//       >
//         <h1
//           style={{
//             color: "#ffffffff",
//             fontWeight: "bold",
//             textAlign: "center",
//             marginBottom: "10px",
//           }}
//         >
//           OUR COMMITMENTS
//         </h1>

//         <button onClick={handleAddMissionVision} style={buttonStyle}>
//           Add+
//         </button>
//       </div>

//       {/* Combined Mission and Vision Section */}
//       <div
//         className="p-4 position-relative"
//         style={{
//           backgroundColor: "#b15dc6ff",
//           margin: "10px",
//           borderRadius: "20px",
//           display: "flex",
//           flexDirection: "row",
//           gap: "20px",
//           width: "calc(100% - 20px)",
//           alignItems: "center",
//           justifyContent: "space-evenly",
//           position: "relative"
//         }}
//       >
//         {/* Mission Card */}
//         <Card 
//           image={misionn} 
//           title="Our Mission" 
//           value={mission} 
//           onChange={setMission}
//           isEditing={isMissionEditing}
//           showEditButton={showMissionEditButton}
//           onEditToggle={handleMissionEditSaveToggle}
//           showThreeDots={showMissionThreeDots}
//           onThreeDotsClick={handleMissionThreeDotsClick}
//           editButtonRef={missionEditButtonRef}
//           threeDotsRef={missionThreeDotsRef}
//         />

//         {/* Vision Card */}
//         <Card 
//           image={vision} 
//           title="Our Vision" 
//           value={visionDesc} 
//           onChange={setVisionDesc}
//           isEditing={isVisionEditing}
//           showEditButton={showVisionEditButton}
//           onEditToggle={handleVisionEditSaveToggle}
//           showThreeDots={showVisionThreeDots}
//           onThreeDotsClick={handleVisionThreeDotsClick}
//           editButtonRef={visionEditButtonRef}
//           threeDotsRef={visionThreeDotsRef}
//         />
//       </div>
      
//       <style>
//         {`
//           /* Hide scrollbar across all platforms */
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//             width: 0;
//             height: 0;
//           }
          
//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//             border:none !important;
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const buttonStyle = {
//   height: "35px",
//   borderRadius: "5px",
//   border: "none",
//   color: "#b15cd6",
//   fontWeight: "bold",
//   cursor: "pointer",
//   width: "80px",
//   marginLeft: "20px",
//   marginTop: "8px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: "5px",
// };

// const sectionButtonStyle = {
//   height: "25px",
//   borderRadius: "50%",
//   border: "none",
//   background: "#b15cd6",
//   color: "#fff",
//   fontWeight: "bold",
//   cursor: "pointer",
//   width: "auto",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: "5px",
// };

// const threeDotsStyle = {
//   position: "absolute",
//   top: "15px",
//   right: "18px",
//   background: "transparent",
//   border: "none",
//   color: "#b15cd6",
//   cursor: "pointer",
//   fontSize: "18px",
//   padding: "5px",
//   borderRadius: "50%",
//   zIndex: 10,
// };

// export default MissionVisionCards;




import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import misionn from "../profileimage/mision.webp";
import vision from "../profileimage/vision.jpg";
import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
import "./missionvissioncards.css"

const MissionVisionCards = () => {
  const [mission, setMission] = useState("");
  const [visionDesc, setVisionDesc] = useState("");
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null);
  const [isMissionEditing, setIsMissionEditing] = useState(false);
  const [isVisionEditing, setIsVisionEditing] = useState(false);
  const [showMissionEditButton, setShowMissionEditButton] = useState(false);
  const [showVisionEditButton, setShowVisionEditButton] = useState(false);
  const [showMissionThreeDots, setShowMissionThreeDots] = useState(true);
  const [showVisionThreeDots, setShowVisionThreeDots] = useState(true);
  
  const timeoutRef = useRef(null);
  const missionEditButtonRef = useRef(null);
  const visionEditButtonRef = useRef(null);
  const missionThreeDotsRef = useRef(null);
  const visionThreeDotsRef = useRef(null);

  // Responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get vendorId from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  // Fetch existing data
  useEffect(() => {
    if (vendorId) fetchAboutUsData(vendorId);
  }, [vendorId]);

  // Click outside detection - hide edit buttons immediately
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMissionEditButtonClicked = missionEditButtonRef.current?.contains(event.target);
      const isVisionEditButtonClicked = visionEditButtonRef.current?.contains(event.target);
      const isMissionThreeDotsClicked = missionThreeDotsRef.current?.contains(event.target);
      const isVisionThreeDotsClicked = visionThreeDotsRef.current?.contains(event.target);
      
      const isAnyInteractiveElementClicked = 
        isMissionEditButtonClicked || 
        isVisionEditButtonClicked || 
        isMissionThreeDotsClicked || 
        isVisionThreeDotsClicked;

      // If click is outside ALL interactive elements, hide everything immediately
      if (!isAnyInteractiveElementClicked) {
        // Only hide if not currently editing
        if (!isMissionEditing) {
          setShowMissionEditButton(false);
          setShowMissionThreeDots(true);
        }
        if (!isVisionEditing) {
          setShowVisionEditButton(false);
          setShowVisionThreeDots(true);
        }
        
        // Clear timeout since we're hiding immediately
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMissionEditing, isVisionEditing]);

  // Auto-hide edit buttons after 5 seconds when visible (only when not editing)
  useEffect(() => {
    // Don't auto-hide if user is actively editing
    if (isMissionEditing || isVisionEditing) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      return;
    }

    // Set timeout for auto-hiding only when edit buttons are visible
    const shouldAutoHide = showMissionEditButton || showVisionEditButton;

    if (shouldAutoHide) {
      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      // Set new timeout only when not editing
      timeoutRef.current = setTimeout(() => {
        setShowMissionEditButton(false);
        setShowVisionEditButton(false);
        setShowMissionThreeDots(true);
        setShowVisionThreeDots(true);
      }, 5000); // 5 seconds
    }

    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [showMissionEditButton, showVisionEditButton, isMissionEditing, isVisionEditing]);

  const fetchAboutUsData = async (vendorId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;
      setAboutUsId(data?.aboutUsId || null);
      setMission(data?.mission || "");
      setVisionDesc(data?.vision || "");
    } catch (err) {
      console.error("Fetch Error:", err.response?.data || err.message);
    }
  };

  // Send data (both POST and PUT) like About Us format
  const sendMissionVision = async (method) => {
    if (!vendorId) return alert("Vendor ID missing!");
    if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing");

    const aboutUsData = { mission, vision: visionDesc };
    const formData = new FormData();
    formData.append("aboutUsData", new Blob([JSON.stringify(aboutUsData)], { type: "application/json" }));

    const url =
      method === "POST"
        ? `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`
        : `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert(method === "POST" ? "Mission & Vision added!" : "Mission & Vision updated!");
        fetchAboutUsData(vendorId);
        setIsMissionEditing(false);
        setIsVisionEditing(false);
        return true;
      } else {
        const err = await res.json();
        alert(`Failed: ${err.message || "Unknown error"}`);
        return false;
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong. Please try again.");
      return false;
    }
  };

  const handleAddMissionVision = async () => {
    await sendMissionVision("POST");
  };

  // Step 1: Three dots click - shows edit button
  const handleMissionThreeDotsClick = () => {
    setShowMissionThreeDots(false);
    setShowMissionEditButton(true);
    // Close vision elements
    setShowVisionEditButton(false);
    setShowVisionThreeDots(true);
    
    // Reset timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleVisionThreeDotsClick = () => {
    setShowVisionThreeDots(false);
    setShowVisionEditButton(true);
    // Close mission elements
    setShowMissionEditButton(false);
    setShowMissionThreeDots(true);
    
    // Reset timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  // Step 2 & 3: Edit/Save button click - toggles between edit and save
  const handleMissionEditSaveToggle = async () => {
    if (isMissionEditing) {
      // Step 3: Save - Save changes and go back to three dots
      if (aboutUsId) {
        const success = await sendMissionVision("PUT");
        if (success) {
          setShowMissionEditButton(false);
          setShowMissionThreeDots(true);
          setIsMissionEditing(false);
        }
      }
    } else {
      // Step 2: Edit - Enable editing and show save button
      setIsMissionEditing(true);
      setShowMissionEditButton(true);
      setShowMissionThreeDots(false);
      
      // Clear timeout when starting to edit
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
  };

  const handleVisionEditSaveToggle = async () => {
    if (isVisionEditing) {
      // Step 3: Save - Save changes and go back to three dots
      if (aboutUsId) {
        const success = await sendMissionVision("PUT");
        if (success) {
          setShowVisionEditButton(false);
          setShowVisionThreeDots(true);
          setIsVisionEditing(false);
        }
      }
    } else {
      // Step 2: Edit - Enable editing and show save button
      setIsVisionEditing(true);
      setShowVisionEditButton(true);
      setShowVisionThreeDots(false);
      
      // Clear timeout when starting to edit
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
  };

  // Responsive helper functions
  const getCardWidth = () => {
    if (isMobile) return "100%";
    if (isTablet) return "48%";
    return "45%";
  };

  const getContainerPadding = () => {
    if (isMobile) return "2vh 1vw";
    if (isTablet) return "3vh 2vw";
    return "4vh 3vw";
  };

  const getTextAreaRows = () => {
    if (isMobile) return 4;
    if (isTablet) return 5;
    return 6;
  };

  const getImageSize = () => {
    if (isMobile) return "60px";
    if (isTablet) return "70px";
    return "80px";
  };

  const getFontSize = () => {
    if (isMobile) return "14px";
    if (isTablet) return "15px";
    return "16px";
  };

  const getHeadingSize = () => {
    if (isMobile) return "18px";
    if (isTablet) return "20px";
    return "24px";
  };

  const getButtonSize = () => {
    if (isMobile) return "30px";
    if (isTablet) return "32px";
    return "35px";
  };

  // Card Component
  const Card = ({ 
    image, 
    title, 
    value, 
    onChange, 
    isEditing, 
    showEditButton, 
    onEditToggle,
    showThreeDots,
    onThreeDotsClick,
    editButtonRef,
    threeDotsRef
  }) => {
    return (
      <div style={{
        backgroundColor: "white",
        borderRadius: "2vmin",
        padding: isMobile ? "15px" : "20px",
        width: getCardWidth(),
        boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
        textAlign: "center",
        position: "relative",
        border: "none",
        marginBottom: isMobile ? "15px" : "0"
      }} className="mission-vission-cards">
        
        {/* Header with title and edit/save button */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 style={{ 
            color: "#b15cd6", 
            margin: "5px",
            fontSize: isMobile ? "16px" : "18px"
          }}>{title}</h5>
          {showEditButton && (
            <button 
              ref={editButtonRef}
              onClick={onEditToggle} 
              style={{
                height: isMobile ? "22px" : "25px",
                borderRadius: "50%",
                border: "none",
                background: "#b15cd6",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                width: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                fontSize: isMobile ? "12px" : "14px"
              }}
              title={isEditing ? "Save Changes" : "Edit Content"}
            >
              {isEditing ? <FaSave /> : <FaEdit />}
            </button>
          )}
        </div>

        {/* Three Dots Button - Step 1 */}
        {showThreeDots && (
          <button 
            ref={threeDotsRef}
            onClick={onThreeDotsClick}
            style={{
              position: "absolute",
              top: isMobile ? "12px" : "15px",
              right: isMobile ? "15px" : "18px",
              background: "transparent",
              border: "none",
              color: "#b15cd6",
              cursor: "pointer",
              fontSize: isMobile ? "16px" : "18px",
              padding: "5px",
              borderRadius: "50%",
              zIndex: 10,
            }}
            title={`Edit ${title}`}
          >
            <FaEllipsisV />
          </button>
        )}

        {/* Image */}
        <img 
          src={image} 
          alt={title} 
          style={{
            width: getImageSize(),
            height: getImageSize(),
            objectFit: "cover",
            borderRadius: "50%",
            marginBottom: isMobile ? "15px" : "20px",
            border: "0.2vmin solid #b15dc6",
          }} 
        />

        {/* Textarea */}
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={getTextAreaRows()}
          readOnly={!isEditing}
          style={{
            width: "100%",
            fontSize: getFontSize(),
            color: "#333",
            lineHeight: "1.2",
            textAlign: "justify",
            border: isEditing ? "0px solid transparent" : "0px solid transparent",
            boxShadow: isEditing ? "none" : "none",
            fontFamily: "math",
            resize: "none",
            outline: "none",
            backgroundColor: isEditing ? "#f5f4f4" : "#f5f4f4",
            borderRadius: "0.8vmin",
            padding: isMobile ? "8px" : "10px",
            transition: "all 0.3s ease",
          }}
          className="hide-scrollbar"
        />
      </div>
    );
  };

  return (
    <div style={{ 
      border: "none", 
      borderRadius: "2vmin", 
      marginTop: isMobile ? "2vh" : "4vh", 
      backgroundColor: "#b15dc6",
      padding: isMobile ? "15px 0" : "20px 0"
    }}>
      <div className="d-flex w-100 px-3 px-md-4 pt-3"
        style={{
          justifyContent: isMobile ? "space-between" : "space-around",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "row" : "row",
          gap: isMobile ? "10px" : "0"
        }}
      >
        <h1
          style={{
            color: "#ffffffff",
            fontWeight: "bold",
            textAlign: isMobile ? "left" : "center",
            marginBottom: "10px",
            fontSize: getHeadingSize(),
            width: isMobile ? "100%" : "auto"
          }}
        >
          OUR COMMITMENTS
        </h1>

        <button onClick={handleAddMissionVision} style={{
          height: getButtonSize(),
          borderRadius: "5px",
          border: "none",
          color: "#b15cd6",
          fontWeight: "bold",
          cursor: "pointer",
          width: isMobile ? "70px" : "80px",
          marginLeft: isMobile ? "0" : "20px",
          marginTop: isMobile ? "0" : "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          fontSize: isMobile ? "12px" : "14px"
        }}>
          Add+
        </button>
      </div>

      {/* Combined Mission and Vision Section */}
      <div
        className="p-3 p-md-4 position-relative"
        style={{
          backgroundColor: "#b15dc6ff",
          margin: isMobile ? "5px" : "10px",
          borderRadius: "2vmin",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "15px" : "20px",
          width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "space-evenly",
          position: "relative"
        }}
      >
        {/* Mission Card */}
        <Card 
          image={misionn} 
          title="Our Mission" 
          value={mission} 
          onChange={setMission}
          isEditing={isMissionEditing}
          showEditButton={showMissionEditButton}
          onEditToggle={handleMissionEditSaveToggle}
          showThreeDots={showMissionThreeDots}
          onThreeDotsClick={handleMissionThreeDotsClick}
          editButtonRef={missionEditButtonRef}
          threeDotsRef={missionThreeDotsRef}
        />

        {/* Vision Card */}
        <Card 
          image={vision} 
          title="Our Vision" 
          value={visionDesc} 
          onChange={setVisionDesc}
          isEditing={isVisionEditing}
          showEditButton={showVisionEditButton}
          onEditToggle={handleVisionEditSaveToggle}
          showThreeDots={showVisionThreeDots}
          onThreeDotsClick={handleVisionThreeDotsClick}
          editButtonRef={visionEditButtonRef}
          threeDotsRef={visionThreeDotsRef}
        />
      </div>
      
      <style>
        {`
          /* Hide scrollbar across all platforms */
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
          }
          
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
            border:none !important;
          }

          @media (max-width: 768px) {
            .px-md-4 {
              padding-left: 1rem !important;
              padding-right: 1rem !important;
            }
            .p-md-4 {
              padding: 1.5rem !important;
            }
          }

          @media (max-width: 480px) {
            .mission-vission-cards {
              margin-bottom: 10px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MissionVisionCards;